var styles = {
  "HorizontalStack": "Polaris-HorizontalStack"
};

export { styles as default };
